<template>
  <v-form
    ref="form"
    lazy-validation
  >
    <v-card>
      <v-card-title v-if="title">
        <span class="text-h3">{{ $t(title) }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              v-if="authUser.isAdmin && type == 'create'"
              cols="12"
              sm="6"
            >
              <v-select
                v-model="options.product"
                dense
                :items="productsList"
                item-value="slug"
                item-text="name"
                :disabled="type == 'edit'"
                :label="$t('select_product_*')"
                :rules="[rules.required]"
                @change="productChange"
              />
            </v-col>
            <v-col
              v-if="authUser.isAdmin && type == 'create'"
              cols="6"
              sm="6"
            >
              <v-autocomplete
                v-model="options.tenant"
                dense
                :loading="tenantLoading"
                :items="tenantsByProduct"
                item-text="name"
                item-value="id"
                :label="$t('select_tenant_*')"
                :rules="[rules.required]"
                @change="onTenantChange"
              />
            </v-col>
            
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="options.fuel_type"
                dense
                :items="fuelTypeList"
                item-value="id"
                item-text="name"
                :label="$t('fuel_type') + ' *'"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="options.fuel_rate"

                dense
                :label="$t('fuel_rate_*')"
                :rules="[rules.required, rules.float(2)]"
              />
            </v-col>   
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small>{{ $t("indicates_required_field") }}</small>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="closeForm()"
        >
          Close
        </v-btn>
        <v-btn
          color="primary"
          text
          :loading="loading"
          @click="saveItem"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";

export default {
  mixins: [validationRules],
  props: {
    type: {
      type: String,
      default() {
        return {
          time: null,
        };
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readOnly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      options: {},      
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      productsList: "products/getProductList",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsFLEET: "tenantsManagement/getTenantsFLEET",
      // 
      fuelTypeList: "fuelPrices/getFuelType"

    }),
    tenantsByProduct() {
      if (this.options?.product) {
        return this.tenantsList.filter(r=> r.product == this.options.product)
      } else {
        return [];
      }
    },
    title() {
      if (this.type == "create") {
        return "add_new";
      } else {
        return "";
      }
    },
  },
  watch: {},
  mounted() {
    if (this.type == "create") {
      this.$store.dispatch('products/list')
      if (!this.authUser.isAdmin) {
        this.options.tenant = this.authUser.tenant_id;
        this.onTenantChange(this.authUser.tenant_id);
      }
    }
    if (this.type == "edit") {
      this.options = { ...this.item };
      this.onTenantChange(this.options.tenant);
    }
  },
  methods: {
    productChange() {
      delete this.options.tenant;
    },
    onTenantChange(v) {
      this.$store.dispatch("fuelTanks/dropDownListTerminal", { tenant_id: v });
      let params = {
        tenant_id: v ?? false,
        vehicle_assigned: false,
      };
      if (this.type == "edit") {
        if (this.options.iot_device) {
          params = {
            tenant_id: v ?? false,
            vehicle_assigned_to: this.options.iot_device,
          };
        }
      }
      this.$store.dispatch("iotDevices/list", params);
    },
    saveItem() {
      const params = {...this.options}
      params.date =  new Date().toISOString().split('T')[0];
      params.country = 'Pakistan';
      params.currency = 'PKR'
      if (this.$refs.form.validate()) {
        this.$emit("onsave", params);
      }
    },
    closeForm() {
      this.$refs.form.reset();
      this.$emit("onclose");
    },
  },
};
</script>
